package com.zq.webproject.model

import kotlinx.serialization.Serializable

/**
 * 邀请的用户信息
 */
@Serializable
data class InvitedUser(
    val id: Int,                        // 用户ID
    val username: String? = null,       // 用户名
    val password: String? = null,       // 密码（敏感信息，实际不应显示）
    val balance: Double? = null,        // 账户余额
    val referralCode: String? = null,   // 推荐码
    val referredBy: Int? = null,        // 推荐人ID
    val phone: String? = null,          // 手机号
    val role: String? = null,           // 用户角色
    val referrerName: String? = null    // 推荐人姓名
)

/**
 * 邀请用户列表响应模型
 */
@Serializable
data class InvitedUsersResponse(
    val code: Int? = null,              // 状态码
    val message: String? = null,        // 消息
    val data: List<InvitedUser>? = null // 邀请的用户列表
)